var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 38,
    viewBox: "0 0 134 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3641 27.2L5.18289 27.1331V10.6925H10.6287V16.5727L21.1243 8.68724L10.3658 0V6.41587L5.18289 6.34891L0 6.28195V31.4767H5.18116H10.6253V37.3586L21.1225 29.4732L10.3641 20.7842V27.2Z",
    fill: "#2075BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8926 18.576L27.3568 28.8263V9.24561L14.8926 18.576Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3574 10.9316H42.0221V18.7746L49.2468 10.9316H52.6344L46.2902 17.9698L52.7248 27.007H49.5642L44.3253 19.9712L42.0221 22.5013V27.0093H39.3574V10.9316Z",
    fill: "#2075BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9142 27.007H59.2055V20.6604L53.334 10.9316H56.2466L60.5587 18.2483L64.8731 10.9316H67.7857L61.9142 20.6604V27.007Z",
    fill: "#2075BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2461 27.007V10.9316H72.9177V24.432H80.1216V27.007H70.2461Z",
    fill: "#2075BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7128 23.351L84.1325 27.007H81.2871L88.2384 10.9316H91.0838L98.0351 27.007H95.1966L93.6164 23.351H85.7128ZM92.532 20.8445L89.6657 14.2194L86.7972 20.8445H92.532Z",
    fill: "#232323"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.628 13.0346C114.148 14.4381 114.908 16.3892 114.908 18.8879C114.908 21.3865 114.171 23.3652 112.695 24.8238C111.222 26.2808 108.964 27.0085 105.923 27.007H100.684V10.9316H106.103C108.932 10.9316 111.107 11.6326 112.628 13.0346ZM112.223 18.9587C112.223 15.2768 110.153 13.4366 106.013 13.4382H103.348V24.4556H106.305C108.219 24.4556 109.686 23.9914 110.707 23.0631C111.728 22.1347 112.234 20.7666 112.223 18.9587Z",
    fill: "#232323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.027 23.351L119.447 27.007H116.602L123.553 10.9316H126.398L133.35 27.007H130.511L128.931 23.351H121.027ZM127.846 20.8445L124.98 14.2194L122.112 20.8445H127.846Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd36afff37e2d42e8401b6ac8bbf0581.svg";
export { ForwardRef as ReactComponent };